/**
 * Product gallery thumbnail switching.
 */

export function initProductGallery() {
	const gallery = document.querySelector('.dc-product-gallery, .woocommerce-product-gallery');

	if (!gallery) {
		return;
	}

	const main = gallery.querySelector('.dc-product-gallery__main img, .woocommerce-product-gallery__image img');
	const thumbs = gallery.querySelectorAll('.dc-product-gallery__thumb, .flex-control-thumbs li');

	if (!main || !thumbs.length) {
		return;
	}

	thumbs.forEach((thumb, index) => {
		const img = thumb.querySelector('img');
		if (!img) {
			return;
		}

		const button = thumb.matches('button') ? thumb : thumb.querySelector('button') || thumb;

		button.addEventListener('click', () => {
			main.src = img.dataset.largeImage || img.src;
			main.srcset = img.dataset.srcset || '';
			main.alt = img.alt || '';

			thumbs.forEach((t) => t.classList.remove('is-active'));
			(thumb.matches('button') ? thumb : thumb).classList.add('is-active');
		});

		if (index === 0) {
			(thumb.matches('button') ? thumb : thumb).classList.add('is-active');
		}
	});
}
